module.exports = __webpack_public_path__ + "static/media/SWSCRC6-6.23e83334.mp3";